/**
 * Cams API
 * Cams
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface PagedTransactionFeePaymentOutputDto { 
    id?: number;
    fromDate?: string;
    toDate?: string;
    totalAmount?: number;
    amountPaid?: number;
    paymentStatus?: string | null;
    tenantId?: number;
}

